import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import IconEdit from '../../components/images/IconEdit.jsx';
import IconSave from '../../components/images/IconSave.jsx';
import IconClear from '../../components/images/IconClear.jsx';
import ReactMarkdown from 'react-markdown';

const MeetingListItem = ({ text, onDelete, onEdit, editable, className }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [currentText, setCurrentText] = useState(text);

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleSave = () => {
        setIsEditing(false);
        onEdit(currentText);
    };

    return (
        <div className={twMerge('flex justify-between py-3 w-full space-x-4', className)}>
            {isEditing ? (
                <textarea
                    value={currentText}
                    onChange={(e) => setCurrentText(e.target.value)}
                    className='text-theme1-text1 rounded-lg border px-4 py-2 border-theme1-border1 w-full outline-none h-[100px]'
                />
            ) : (
                <span className='text-theme1-title2 text-base'>
                    <ReactMarkdown>{currentText}</ReactMarkdown>
                </span>
            )}

            {editable && (
                <div className='flex space-x-4 items-start mt-[5px]'>
                    {isEditing ? (
                        <button onClick={handleSave}>
                            <IconSave className='w-6 h-6 fill-theme1-primary' />
                        </button>
                    ) : (
                        <button onClick={handleEdit}>
                            <IconEdit className='w-6 h-6 stroke-theme1-primary' />
                        </button>
                    )}
                    <button onClick={onDelete}>
                        <IconClear className='fill-theme1-primary w-6 h-6' />
                    </button>
                </div>
            )}
        </div>
    );
};

export default MeetingListItem;
